import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalAlert } from "../su/Modals.js";

export default class PageSearch extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    // console.log("PageSearch");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error();
    }

    PageCommon.disable($(".js-search-submit"), true);
    $(".js-search-text").keyup(this.onCheckData.bind(this));
    $(".js-search-submit").on("click", this.onDoSubmit.bind(this));
    $("body").keydown(this.onSendData.bind(this));    
  }

  onCheckData() {
    let minlen = 2;
    let txt = $.trim($(".js-search-text").val())
    let tokens = txt.split(/[ \r\n\t;,.:\-_!\"/\\?^\[\]<>()%?*~+'|&]+/);
    let isValid = false;
    for (var x of tokens) {
      if (x.length >= minlen)
        isValid = true;
    }
    if (isValid) {
      PageCommon.disable($(".js-search-submit"), false);
      return true;
    } else {
      PageCommon.disable($(".js-search-submit"), true);
      return false;
    }
  }

  onSendData(e) {
    if (e.which == 13 && this.onCheckData()) {
      this.onDoSubmit();
    }
  }

  onDoSubmit(e) {
    this.showPreloader(true);
    let rq = {
      SearchText: $.trim($(".js-search-text").val()),
    }
    thatServiceManeger.standardCall("/api/app/fulltextsearch", rq, this.onDoSubmitHandler.bind(this));
  }

  onDoSubmitHandler(rs) {
    // console.log(rs);
    this.showPreloader(false);

    let showError = false;
    let errorMessage = "Si è verificato un errore"
    if (rs.StatusCode !== 200) {
      showError = true;
    } else {
      showError = !rs.Success;
    }
    if (showError) {
      let modal = new ModalAlert($("#template-modalAlert"));
      modal.create(
        {
          title: "ERRORE",
          body: errorMessage,
          close: "CHIUDI",
          error: true
        });
      modal.init();
      return;
    } else {
      if (rs.Items.length == 0) {
        $('.js-result-title').hide();
        $('.js-result-list').hide();
        let modal = new ModalAlert($("#template-modalAlert"));
        modal.create(
          {
            title: "",
            body: "Nessun risultato!",
            close: "CHIUDI"
          });
        modal.init();
        return;
      } else {
        $('.js-result-title').show();
        $('.js-result-list').show();

        $('.js-result-list').html("");
        for (let x = 0; x < rs.Items.length; x++) {
          let item = rs.Items[x];
          if (item.ObjectType === 0) {
            let el = $('#template-percorso').clone();
            el.attr('id', `percorso-${item.UidObject}`);
            $(".js-img-percorso", el).attr("src", `${item.PathImage}`);
            $(".js-title-percorso", el).html(item.PathTitle);
            $(".js-url-percorso", el).attr("href", `/educazione/intro/percorso/${item.PathSlug}`);
            $(".js-meta-data", el).html(item.ObjectData);
            $(".js-result-list").append(el);
          } else if (item.ObjectType === 1) {
            let el = $('#template-podcast').clone();
            el.attr('id', `podcast-${item.UidObject}`);
            $(".js-img-podcast", el).attr("src", `${item.PodcastImage}`);
            $(".js-title-podcast", el).html(item.PodcastTitle);
            $(".js-url-podcast", el).attr("href", `/educazione/ascolta/${item.PodcastSlug}`);
            $(".js-result-list").append(el);
          } else if (item.ObjectType === 2) {
            let el = $('#template-image').clone();
            // console.log(el);
            el.attr('id', `image-${item.UidObject}`);
            $(".js-img-image", el).attr("src", `${item.ImagePath}`);
            $(".js-caption-image", el).html(item.ImageCaption);
            $(".js-meta-description", el).html(item.ImageDescription);
            const paths = item.ObjectData.split(";");
            try {
              for (let y = 0; y < paths.length; y++) {
                const pathWithSlug = paths[y];
                if (pathWithSlug !== "" && pathWithSlug !== undefined) {
                  const pathData = pathWithSlug.split("|");
                  let htmlItem = `<a href=\"/educazione/intro/percorso/${pathData[1]}" ><h3>${pathData[0]}</h3></a>`;
                  // console.log(htmlItem);
                  $(".js-path-list", el).append(htmlItem);
                }
              }
            } catch (e) {
              console.log(e);
            }
            $(".js-result-list").append(el);
          }
        }
        $('.js-result-list').focus();
        if (window.innerWidth > 767) {
          window.scroll({
            top: 768 + 177
          });
        } else {
          window.scroll({
            top: 768 + 90
          })
        }
        /*
         * Swiper:start
         */
        // check if swiper already in main
        let main = document.querySelector(".js-result-list");
        if (main.querySelector(".js-img-lightbox-wrap-search")) {
          main.querySelector(".js-img-lightbox-wrap-search").remove();
        }
        let thumbs = ".js-gallery-img-preview";
        if (main.querySelector(thumbs)) {
          // clone swiper and append to main
          let slider_clone = document.querySelector(".js-img-lightbox-wrap-search").cloneNode(true);
          main.appendChild(slider_clone);
          // nThumbs = nSlides
          thumbs = main.querySelectorAll(thumbs);          
          // console.log(thumbs.length);
          for (let i = 1; i < thumbs.length; i++) {
            let slide_clone = slider_clone.querySelector(".swiper-slide").cloneNode(true);
            slider_clone.querySelector(".swiper-wrapper").appendChild(slide_clone);            
          }
          // add class to init
          main.querySelector(".js-swiper-lightbox").classList.add("swiper-init");
          let slides = slider_clone.querySelectorAll(".swiper-slide");
          for (let i = 0; i < thumbs.length; i++) {
            // get slide data from thumbs
            let img_url = thumbs[i].querySelector("img").getAttribute("src");
            let img_caption = thumbs[i].querySelector("figcaption").innerHTML;
            let img_parent = thumbs[i].querySelector(".meta-parent").cloneNode(true);
            slides[i].querySelector("img").setAttribute("src", img_url);
            slides[i].querySelector("figcaption").innerHTML = img_caption;
            slides[i].querySelector(".caption-left").appendChild(img_parent);
          }
          // init swiper
          let swiper = new Swiper(".swiper-init", {
            loop: false,
            slidesPerView: 1,            
            navigation: {
              nextEl: ".js-lightbox-btn-next",
              prevEl: ".js-lightbox-btn-prev",
            },
            breakpoints: {
              821: {
                allowTouchMove: false,
              }
            }
          });
          let current_index = 0;
          let close = slider_clone.querySelectorAll(".js-lightbox-close-search");
          let observe = slider_clone.querySelectorAll(".js-icon-observe-search");
          for (let i = 0; i < thumbs.length; i++) {
            // show swiper
            thumbs[i].addEventListener("click", (e) => {
              current_index = i;
              swiper.slideTo(current_index);
              $(".js-img-lightbox-wrap-search", "main").fadeIn();
            });
            // close swiper
            close[i].addEventListener("click", (e) => {
              current_index = 0;
              $(".js-img-lightbox-wrap-search", "main").fadeOut();
            });
            // show captions
            observe[i].addEventListener("click", (e) => {
              $(".js-icon-observe-search").toggleClass("is-hidden");
              $(".swiper").addClass("swiper-no-swiping");
              setTimeout(() => {
                $(".swiper").removeClass("swiper-no-swiping");
              }, 700);
              if ($(".js-icon-observe-search").hasClass("is-hidden")) {                
                $(".js-img-lightbox-cont").addClass("has-visible-captions");
              } else {
                $(".js-img-lightbox-cont").removeClass("has-visible-captions");
              }
            });
          }
        }
        /*
         * Swiper:end
         */
      }
      return;
    }
  }
}